import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatTime(timestamp) {
  const date = new Date(timestamp);
  const now = new Date();
  const diff = now - date;
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (days === 0) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (days === 1) {
    return 'Gestern';
  } else if (days < 7) {
    return date.toLocaleDateString([], { weekday: 'short' });
  } else {
    return date.toLocaleDateString([], { day: '2-digit', month: '2-digit' });
  }
}

export function formatMessageTime(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function getChatName(chat, currentUserId) {
  if (chat.is_group) {
    return chat.name || 'Gruppe';
  }
  const otherParticipant = chat.participants?.find(p => p.id !== currentUserId);
  return otherParticipant?.username || 'Unbekannt';
}

export function getChatAvatar(chat, currentUserId) {
  if (chat.is_group) {
    return chat.avatar;
  }
  const otherParticipant = chat.participants?.find(p => p.id !== currentUserId);
  return otherParticipant?.avatar;
}

export function isUserOnline(chat, currentUserId) {
  if (chat.is_group) return false;
  const otherParticipant = chat.participants?.find(p => p.id !== currentUserId);
  return otherParticipant?.is_online || false;
}

export function truncateText(text, maxLength = 50) {
  if (!text || text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
}
